import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import isEmpty from 'lodash/isEmpty';
import { Context } from '@grandvisionhq/carts-v2';
import { toast } from '@grandvisionhq/common';
import { useLink } from '@grandvisionhq/frk-routing';
import { useSync } from '@grandvisionhq/lib-utils-w3c';
import { useIntl, useSelector, useDispatch } from '@grandvisionhq/state';
import { updateCartState } from '../actions.js';
import { useCheckoutSettings } from '../context/CheckoutSettings/context.js';
import '@grandvisionhq/graphql';
import '@grandvisionhq/payments';
import '@grandvisionhq/utils';
import '@grandvisionhq/api-client';
import { useRestoreCartShippingMethod } from '../hooks/carts/use-restore-cart-shipping-method.js';
import { selectShippingMethod, selectStore, selectPickupPoint } from '../StepShipping/actions.js';
import { isShippingStepValid, getSelectedShippingMethod, shouldValidateServiceStore, getSelectedStore, getSelectedPickupPoint } from '../StepShipping/selectors.js';
import '@grandvisionhq/auth';
import { getServiceStore } from '../selectors.js';
import { useSetCustomerDetails } from '../hooks/operations/use-set-customer-details.js';
import '@grandvisionhq/lib-utils-cart';
import '@grandvisionhq/svc-tealium/events';
import '../mappers/errors-mapping.js';
import '../operations/mutations/set-customer-details.js';
import '../operations/mutations/set-service-store.js';
import '../operations/mutations/set-shipping-method.js';
import '../operations/mutations/set-shipping-state.js';
import '../operations/mutations/create-apple-pay-session.js';
import '../operations/mutations/recreate-ordered-checkout.js';
import '../utils/get-customer-details-payload.js';
import { isPickupStore, isPickupPoint } from '../utils/shipping-method.js';
import 'history';
import '../models/cart/cart-state.js';
import { CheckoutStepErrorType } from '../models/checkout/checkout-step-error-type.js';
import '../models/checkout-settings.js';
import { ShippingMethod } from '../models/step-shipping/shipping-methods.js';
import '../models/shared.js';
import '../utils/has-cart-errors.js';
import '@grandvisionhq/fun-orders';
import '@grandvisionhq/analytics';
import '../operations/fragments/checkout-mutation-result.js';
import '../operations/fragments/cart-mutation-failures.js';
import '../operations/fragments/recreate-ordered-checkout-failure.js';
import '../operations/fragments/recreate-ordered-checkout-result.js';
import '../operations/fragments/paypal-payment.js';
import '../operations/fragments/saved-user-details.js';
import '../operations/queries/get-checkout-state.js';
import '../operations/queries/get-user-details.js';
import { useShippingMethodSelection } from '../StepShipping/modules/ShippingMethods/hooks/use-shipping-method-selection.js';
import { useShippingMethodsList } from '../StepShipping/modules/ShippingMethods/hooks/use-shipping-methods-list.js';
import { shippingMethodsFailed } from '../StepShipping/modules/ShippingMethods/state/actions.js';
import { usePrepareCustomerDetails } from './hooks/use-prepare-customer-details.js';
import { StepOverview } from './StepOverview.js';

const StepOverviewContainer = (props)=>{
    const { onNextStep , onPrevStep , shippingMethodsAsides  } = props;
    const { getLabel  } = useIntl();
    const { customerDetails  } = usePrepareCustomerDetails();
    const isShippingStepValid$1 = useSelector(isShippingStepValid);
    const serviceStore = useSelector(getServiceStore);
    const { serviceStore: serviceStoreOptions , features  } = useCheckoutSettings();
    const { cart , called , loading  } = Context.useCart();
    const selectedShippingMethod = useSelector(getSelectedShippingMethod);
    const isPickupStore$1 = isPickupStore(selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method);
    const validateServiceStore = useSelector(shouldValidateServiceStore);
    const selectedStore = useSelector(getSelectedStore);
    const selectedPickupPoint = useSelector(getSelectedPickupPoint);
    const { onClick: navigateToCart  } = useLink({
        route: 'cart.overview'
    }, {
        replace: true
    }) || {};
    const broadCastChannel = useSync('new-cart-created').getChannel();
    const dispatch = useDispatch();
    const isPickupPoint$1 = isPickupPoint(selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method);
    const { restoreShippingMethod  } = useRestoreCartShippingMethod();
    broadCastChannel.onmessage = ()=>{
        toast.failed('cart.errors.cartNotInActiveState');
        navigateToCart === null || navigateToCart === void 0 ? void 0 : navigateToCart();
    };
    const isOverviewStepValid = React.useMemo(()=>{
        var ref;
        if (validateServiceStore && (features === null || features === void 0 ? void 0 : features.isServiceStoreEnabled) && !((ref = serviceStoreOptions === null || serviceStoreOptions === void 0 ? void 0 : serviceStoreOptions.isOptional) !== null && ref !== void 0 ? ref : true) && !isPickupStore$1 && !serviceStore) {
            return false;
        }
        return isShippingStepValid$1;
    }, [
        validateServiceStore,
        features === null || features === void 0 ? void 0 : features.isServiceStoreEnabled,
        isPickupStore$1,
        serviceStore,
        serviceStoreOptions === null || serviceStoreOptions === void 0 ? void 0 : serviceStoreOptions.isOptional,
        isShippingStepValid$1, 
    ]);
    const onShippingMethodLoadError = React.useCallback(()=>{
        dispatch(shippingMethodsFailed({
            message: 'Unable to load shipping methods'
        }));
    }, [
        dispatch
    ]);
    const { shippingMethodList , reloadShippingMethods  } = useShippingMethodsList(()=>{}, onShippingMethodLoadError);
    const onError = React.useCallback(()=>{
        restoreShippingMethod();
        reloadShippingMethods();
    }, [
        reloadShippingMethods,
        restoreShippingMethod
    ]);
    const { handleOnShippingMethodSelected  } = useShippingMethodSelection({
        shippingMethodList: shippingMethodList || [],
        onError
    });
    const onShippingMethodSelect = React.useCallback((method)=>{
        dispatch(selectShippingMethod({
            shippingMethod: {
                method: method,
                isValid: true,
                isTouched: true
            }
        }));
        switch(method){
            case ShippingMethod.Pickup:
                if (selectedStore && selectedStore.globalStoreId) {
                    handleOnShippingMethodSelected(method, selectedStore.globalStoreId);
                }
                break;
            case ShippingMethod.PickupPoint:
                if (selectedPickupPoint) {
                    handleOnShippingMethodSelected(method);
                }
                break;
            default:
                handleOnShippingMethodSelected(method);
                break;
        }
    }, [
        dispatch,
        handleOnShippingMethodSelected,
        selectedPickupPoint,
        selectedStore
    ]);
    // This check should be done on page load and not when isOverviewStepValid changes
    // because if user is redirected to shipping step, we don't want to redirect them back
    // to shipping step again and again.
    const checkStepOverviewValidity = React.useCallback(()=>{
        if (!isOverviewStepValid) {
            onPrevStep(CheckoutStepErrorType.ShippingStepFailed);
        }
    }, [
        isOverviewStepValid,
        onPrevStep
    ]);
    React.useEffect(()=>{
        if (cart && called && !loading) {
            checkStepOverviewValidity();
        }
    // Need to check validity of overview step and redirect user to shipping step
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cart,
        called,
        loading
    ]);
    const onCompleted = React.useCallback((operation)=>{
        (cart === null || cart === void 0 ? void 0 : cart.checkoutState) && dispatch(updateCartState({
            cartState: cart === null || cart === void 0 ? void 0 : cart.checkoutState
        }));
        // The payment page needs the fresh cart data.
        // If we want to ditch redux, everything should rely on apollo
        operation === 'MUTATION' && onNextStep();
    }, [
        cart === null || cart === void 0 ? void 0 : cart.checkoutState,
        dispatch,
        onNextStep
    ]);
    const { setCustomerDetails  } = useSetCustomerDetails({
        onCompleted,
        onError: ()=>{
            toast.failed('checkout.errors.form.general');
        }
    });
    const onNextClick = ()=>{
        if (!isOverviewStepValid) {
            onPrevStep();
        } else if (customerDetails && !isEmpty(customerDetails)) {
            setCustomerDetails(customerDetails);
        }
    };
    const onStoreSelect = function() {
        var _ref = swcHelpers.asyncToGenerator(function*(store) {
            const { globalStoreId  } = store;
            if ((selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method) && isPickupStore$1 && !isPickupStore(cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key)) {
                dispatch(selectStore({
                    store
                }));
                yield handleOnShippingMethodSelected(selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method, globalStoreId);
            }
            if ((cart === null || cart === void 0 ? void 0 : cart.shippingMethod) && isPickupStore(cart.shippingMethod.key) && (selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.globalStoreId) !== globalStoreId) {
                dispatch(selectStore({
                    store
                }));
                yield handleOnShippingMethodSelected(cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key, globalStoreId);
            }
        });
        return function onStoreSelect(store) {
            return _ref.apply(this, arguments);
        };
    }();
    const onPickupPointSelect = function() {
        var _ref = swcHelpers.asyncToGenerator(function*(pickupPoint) {
            if (!pickupPoint) {
                return;
            }
            dispatch(selectPickupPoint({
                pickupPoint
            }));
            if ((selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method) && !isPickupPoint(cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key)) {
                yield handleOnShippingMethodSelected(selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method);
            }
        });
        return function onPickupPointSelect(pickupPoint) {
            return _ref.apply(this, arguments);
        };
    }();
    const labels = React.useMemo(()=>({
            generic: {
                title: getLabel('checkout.generic.title'),
                deliveryAddress: getLabel('checkout.deliveryAddress')
            },
            yourDetails: getLabel('checkout.yourDetails'),
            billingAddress: getLabel('checkout.billingAddress'),
            completed: {
                shipmentDetailsDelivery: getLabel('checkout.completed.shipmentDetails.delivery')
            },
            contactTitle: getLabel('checkout.contact.title'),
            customerTypeCompany: getLabel('checkout.customerType.company'),
            serviceStoreTitle: getLabel('checkout.serviceStore.title'),
            shipmentAddress: getLabel('checkout.shipment.address'),
            summary: {
                delivery: getLabel('checkout.summary.shipment.delivery'),
                deliveryExpress: getLabel('checkout.summary.shipment.deliveryExpress'),
                pickupStore: getLabel('checkout.summary.shipment.pickup'),
                pickupPoint: getLabel('checkout.summary.shipment.pickupPoint'),
                nearestPickup: getLabel('checkout.summary.shipment.nearestPickup'),
                address: getLabel('checkout.summary.shipment.address'),
                deliveryPremium: getLabel('checkout.summary.shipment.deliveryPremium'),
                deliveryResponsible: getLabel('checkout.summary.shipment.deliveryResponsible')
            },
            editModal: {
                save: getLabel('common.actions.save')
            },
            differentDeliveryAddress: getLabel('checkout.shipment.differentDeliveryAddress'),
            nearestPickupMessage: getLabel('checkout.summary.shipment.nearestPickup.message')
        })
    , [
        getLabel
    ]);
    const handleClose = ()=>{
        restoreShippingMethod();
    };
    return /*#__PURE__*/ React.createElement(StepOverview, {
        cartComponent: props.cartComponent,
        isPickupPoint: isPickupPoint$1,
        isPickupStore: isPickupStore$1,
        labels: labels,
        onEdit: onPrevStep,
        onNextClick: onNextClick,
        onPrevClick: onPrevStep,
        selectedPickupPoint: selectedPickupPoint,
        selectedStore: selectedStore,
        serviceStore: serviceStore,
        shippingMethod: selectedShippingMethod,
        shippingMethodsAsides: shippingMethodsAsides,
        onPickupPointSelect: onPickupPointSelect,
        onStoreSelect: onStoreSelect,
        shippingMethodList: shippingMethodList,
        handleOnShippingMethodSelected: onShippingMethodSelect,
        onShippingModalClose: handleClose
    });
};

export { StepOverviewContainer };
//# sourceMappingURL=StepOverviewContainer.js.map
